import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initSentry } from './lib/sentry';
import { installPreloadErrorRecovery } from './lib/preload-recovery';
import './styles/globals.css';

// Sentry runs before React mounts so any error in the initial render
// is captured. No-op until VITE_SENTRY_DSN is set (dev default).
initSentry();
// Recover from stale lazy-chunk imports after a deploy (reload once).
installPreloadErrorRecovery();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
